// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"ae60cab5","340":"e47f7e6c"}[chunkId] + ".chunk.js";
};